import React from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { QUESTIONS } from '../data/quizData';

export const QuestionScreen = ({ index, selected, onSelect, onBack, onNext }) => {
  const q = QUESTIONS[index];
  const total = QUESTIONS.length;
  const progress = ((index + (selected != null ? 1 : 0)) / total) * 100;
  const isLast = index === total - 1;
  const canGoBack = index > 0;
  const canGoNext = selected != null;

  return (
    <section
      data-testid={`question-screen-${index + 1}`}
      className="screen-enter mx-auto w-full max-w-[640px] px-5 sm:px-8 pt-8 sm:pt-12 pb-16"
      key={`question-${index}`}
    >
      {/* Progress */}
      <div className="mb-8" data-testid="quiz-progress-row">
        <div className="flex items-center justify-between mb-3">
          <span className="section-label" data-testid="quiz-progress-label">
            Question {index + 1} of {total}
          </span>
          <span
            className="font-body text-[12px]"
            style={{ color: '#3D3830', letterSpacing: '0.08em' }}
            data-testid="quiz-progress-percent"
          >
            {Math.round(progress)}%
          </span>
        </div>
        <div
          className="h-[4px] w-full rounded-full overflow-hidden"
          style={{ backgroundColor: 'rgba(184, 167, 143, 0.35)' }}
          data-testid="quiz-progress-bar"
        >
          <div
            className="h-full rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%`, backgroundColor: '#3D3830' }}
          />
        </div>
      </div>

      {/* Question */}
      <h2
        data-testid="quiz-question-text"
        className="font-heading text-[26px] sm:text-[32px] leading-[1.18] mb-7"
        style={{ fontWeight: 500, color: '#3D3830' }}
      >
        {q.text}
      </h2>

      {/* Answers */}
      <div className="flex flex-col gap-3" data-testid="quiz-answer-list">
        {q.options.map((opt, i) => {
          const isSelected = selected === i;
          return (
            <button
              key={i}
              data-testid={`quiz-answer-${i}`}
              onClick={() => onSelect(i)}
              className="answer-card text-left rounded-2xl px-5 py-4 sm:px-6 sm:py-5"
              style={{
                backgroundColor: isSelected ? '#e2dae8' : 'rgba(255,255,255,0.65)',
                border: `1.5px solid ${isSelected ? '#3D3830' : 'rgba(206,197,212,0.45)'}`,
                color: '#3D3830',
              }}
              aria-pressed={isSelected}
            >
              <div className="flex items-start gap-3">
                <span
                  className="mt-1 flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center"
                  style={{
                    backgroundColor: isSelected ? '#3D3830' : 'transparent',
                    border: `1.5px solid ${isSelected ? '#3D3830' : '#B8A78F'}`,
                  }}
                  aria-hidden
                >
                  {isSelected && <span className="w-2 h-2 rounded-full bg-white" />}
                </span>
                <span className="font-body text-[15px] sm:text-[16px] leading-[1.5]">
                  {opt.label}
                </span>
              </div>
            </button>
          );
        })}
      </div>

      {/* Nav */}
      <div className="mt-9 flex items-center justify-between">
        <button
          data-testid="quiz-back-button"
          onClick={onBack}
          disabled={!canGoBack}
          className="btn-ghost"
          aria-label="Go back"
        >
          <span className="inline-flex items-center gap-2">
            <ArrowLeft size={14} strokeWidth={1.5} /> Back
          </span>
        </button>
        <button
          data-testid="quiz-next-button"
          onClick={onNext}
          disabled={!canGoNext}
          className="btn-primary"
        >
          {isLast ? 'See my result' : 'Next'}
          <ArrowRight size={16} strokeWidth={1.5} />
        </button>
      </div>
    </section>
  );
};
